<template>
  <div id="account-header" class="account-header" v-bind:class="{
    'row-header': ['xs', 'sm', 'md'].includes($vuetify.breakpoint.name)
  }">
    <nav
        class="castfy-menu"
        v-bind:class="{'flex': ['xs'].includes($vuetify.breakpoint.name) && !showMenu}"
    >
      <v-btn
          type="button"
          class="box box__primary box__square box__dark box__menu_toggler condensed"
          v-if="['xs', 'sm'].includes($vuetify.breakpoint.name)"
          @click.prevent="showMenu = !showMenu"
      >
        Menu
      </v-btn>
      <v-list
          v-bind:class="{
            'show': ['md', 'lg', 'xl'].includes($vuetify.breakpoint.name) || this.showMenu
          }"
      >
        <v-row no-gutters>
          <v-col cols="12" md="5" lg="12">
            <v-list-item
                class="box box__primary box__dark box__menu_item"
                :to="{name: 'ProfessionalAccountAgenda'}"
                active-class="active"
            >
              <v-list-item-icon>
                <v-icon class="castfy-icon castfy-icon__calendar"></v-icon>
              </v-list-item-icon>
              <span class="condensed">Minha agenda</span>
            </v-list-item>
          </v-col>

          <v-col cols="12" md="5" lg="12">
            <v-list-item
                class="box box__primary box__dark box__menu_item"
                :to="{name: 'ProfessionalAccountInvites'}"
                active-class="active"
            >
              <v-list-item-icon>
                <v-icon class="castfy-icon castfy-icon__new"></v-icon>
              </v-list-item-icon>
              <span class="condensed">Jobs Novos <v-badge v-if="newJobs" :content="newJobs"></v-badge></span>
            </v-list-item>
          </v-col>

          <v-col cols="12" md="5" lg="12">
            <v-list-item
                class="box box__primary box__dark box__menu_item"
                :to="{name: 'JobHistory'}"
                active-class="active"
            >
              <v-list-item-icon>
                <v-icon class="castfy-icon castfy-icon__history"></v-icon>
              </v-list-item-icon>
              <span class="condensed">Histórico de Jobs</span>
            </v-list-item>
          </v-col>

          <v-col cols="12" md="5" lg="12">
            <v-list-item
              class="box box__primary box__dark box__menu_item"
              :to="{name: 'ProfessionalWallet'}"
              active-class="active"
            >
              <v-list-item-icon>
                <v-icon>wallet</v-icon>
              </v-list-item-icon>
              <span class="condensed">Demonstrativo financeiro</span>
            </v-list-item>
          </v-col>

          <v-col cols="12" md="5" lg="12">
            <v-list-item
                class="box box__primary box__dark box__menu_item"
                :to="$route.name === 'ProfessionalProfile' ? null : {name: 'ProfessionalProfile'}"
                active-class="active"
            >
              <v-list-item-icon v-if="$store.state.session.user.photo_images && $store.state.session.user.photo_images.user_default">
                <div
                    class="media-preview"
                    :style="`background-image:url('${$store.state.session.user.photo_images.user_default}')`"
                    @click="$refs['changeProfilePicture'] ? $refs['changeProfilePicture'].selectProfilePicture() : null"
                ></div>
              </v-list-item-icon>
              <v-list-item-icon v-else>
                <v-icon>person</v-icon>
              </v-list-item-icon>
              <span class="condensed">Dados do Perfil</span>
            </v-list-item>
          </v-col>
        </v-row>
      </v-list>

      <v-list class="show current-menu-item" v-if="['xs', 'sm'].includes($vuetify.breakpoint.name) && !showMenu">
        <v-row no-gutters>
          <v-col
              cols="12"
              md="5"
              lg="12"
              v-if="$route.name === 'ProfessionalAccountAgenda'"
          >
            <v-list-item
                class="box box__secondary box__dark box__menu_item"
                :to="{name: 'ProfessionalAccountAgenda'}"
                active-class="active"
            >
              <v-list-item-icon>
                <v-icon class="castfy-icon castfy-icon__calendar"></v-icon>
              </v-list-item-icon>
              <span class="condensed" v-if="['sm'].includes($vuetify.breakpoint.name)">Minha agenda</span>
            </v-list-item>
          </v-col>

          <v-col
              cols="12"
              md="5"
              lg="12"
              v-if="$route.name === 'ProfessionalAccountInvites'"
          >
            <v-list-item
                class="box box__secondary box__dark box__menu_item"
                :to="{name: 'ProfessionalAccountInvites'}"
                active-class="active"
            >
              <v-list-item-icon>
                <v-icon class="castfy-icon castfy-icon__new"></v-icon>
              </v-list-item-icon>
              <span class="condensed" v-if="['sm'].includes($vuetify.breakpoint.name)">Jobs Novos <v-badge v-if="newJobs" :content="newJobs"></v-badge></span>
            </v-list-item>
          </v-col>

          <v-col
              cols="12"
              md="5"
              lg="12"
              v-if="$route.name === 'JobHistory'"
          >
            <v-list-item
                class="box box__secondary box__dark box__menu_item"
                :to="{name: 'JobHistory'}"
                active-class="active"
            >
              <v-list-item-icon>
                <v-icon class="castfy-icon castfy-icon__history"></v-icon>
              </v-list-item-icon>
              <span class="condensed" v-if="['sm'].includes($vuetify.breakpoint.name)">Histórico de Jobs</span>
            </v-list-item>
          </v-col>

          <v-col
              cols="12"
              md="5"
              lg="12"
              v-if="$route.name === 'ProfessionalProfile'"
          >
            <v-list-item
                class="box box__secondary box__dark box__menu_item"
                :to="$route.name === 'ProfessionalProfile' ? null : {name: 'ProfessionalProfile'}"
                active-class="active"
            >
              <v-list-item-icon v-if="$store.state.session.user.photo_images && $store.state.session.user.photo_images.user_default">
                <div
                    class="media-preview"
                    :style="`background-image:url('${$store.state.session.user.photo_images.user_default}')`"
                    @click="$refs['changeProfilePicture'] ? $refs['changeProfilePicture'].selectProfilePicture() : null"
                ></div>
              </v-list-item-icon>
              <v-list-item-icon v-else>
                <v-icon>person</v-icon>
              </v-list-item-icon>
              <span class="condensed" v-if="['sm'].includes($vuetify.breakpoint.name)">Dados do Perfil</span>
            </v-list-item>
          </v-col>
        </v-row>
      </v-list>
    </nav>
    <v-row
        v-bind:class="{'justify-end align-content-end': ! ['xs', 'sm', 'md'].includes($vuetify.breakpoint.name)}"
    >
      <ChangeProfilePicture view="professional" v-if="$route.name === 'ProfessionalProfile' && !['xs', 'sm', 'md'].includes($vuetify.breakpoint.name)"></ChangeProfilePicture>
    </v-row>

    <ChangeProfilePicture view="professional" v-if="$route.name === 'ProfessionalProfile' && ['xs', 'sm', 'md'].includes($vuetify.breakpoint.name)" ref="changeProfilePicture" hidden></ChangeProfilePicture>
  </div>
</template>

<script>
import ChangeProfilePicture from '@/components/Account/components/ChangeProfilePicture/Index'
import getApiClient from '@/plugins/api-client'

export default {
  name: 'ProfessionalAccountHeader',
  data: function () {
    return {
      showMenu: true,
      newJobs: 0
    }
  },
  components: {
    ChangeProfilePicture
  },
  methods: {
    fetchNewJobs() {
      const self = this,
          api = getApiClient(self.$store)

      api.get('/jobs', {
        params: {
          status: 0,
          'event.start[after]': new Date()
        }
      })
          .then(result => {
            self.newJobs = result.data['hydra:totalItems']
          })
          .catch(error => {
            console.log(error)
          })
    },
  },
  mounted() {
    const self = this

    self.fetchNewJobs()

    self.$root.$on('updateNewJobsCount', function() {
      self.fetchNewJobs()
    })
  }
}
</script>
